import type { JSX, VoidComponent } from "solid-js";
import type { ExtendableInputProps } from "./Input";
import Input from "./Input";
import TextareaAutosize from "solid-textarea-autosize";

type TextAreaInputProps = {
  value?: string;
  maxLength: number;
  placeholder?: string;
  onBlur: JSX.FocusEventHandler<HTMLTextAreaElement, FocusEvent>;
  onInput?: JSX.InputEventHandler<HTMLTextAreaElement, InputEvent>;
} & ExtendableInputProps;

const TextAreaInput: VoidComponent<TextAreaInputProps> = (props) => {
  const hasError = () => props.errorMessage !== undefined;

  return (
    <Input {...props}>
      {(id) => (
        <TextareaAutosize
          id={id}
          class="max-h-140 min-h-20 w-full rounded-sm border p-2 text-base-regular text-primary placeholder:text-placeholder focus-visible:outline-default"
          classList={{
            "border-default bg-surface-default": !hasError(),
            "border-error bg-surface-destructive": hasError(),
          }}
          value={props.value ?? ""}
          maxLength={props.maxLength}
          placeholder={props.placeholder}
          onInput={(e) => {
            props.onInput?.(e);
          }}
          onBlur={(e) => {
            props.onBlur(e);
          }}
        />
      )}
    </Input>
  );
};

export default TextAreaInput;
